<template>
    <v-layout row wrap>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-layout>
                <v-flex xs12 sm6 v-for="column in columns" :key="column.ColumnNumber">
                    <v-layout row wrap v-for="supplier in column.Suppliers" :key="supplier.ID" class="supplier">
                        <v-flex xs12>
                            <span class="title">{{supplier.Name}}</span>
                            <v-checkbox v-if="allowEmailResend" label="Select to resend email" class="notPrinted" :value="value[supplier.ID] == null ? false : value[supplier.ID].resendEmail" @change="updateSelectedSupplier(supplier.ID, $event)"></v-checkbox>
                        </v-flex>
                        <v-flex xs12 v-for="ordersProduct in supplier.OrdersProducts" :key="ordersProduct.ProductID" class="subheading">
                            <span>{{ ordersProduct.Quantity }} x <strong>{{ ordersProduct.CategoryName }}</strong> - {{ ordersProduct.ProductName }}</span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import validationRules from "../../helpers/validationrules";
import ErrorAlert from "../common/ErrorAlert";
import auth from '@/services/auth';

export default {
    components: {
        ErrorAlert
    },
    props: [
        'loading',
        'ordersProducts',
        'value',
        'allowEmailResend'
    ],
    data() {
        return {
            rules: validationRules.rules
        };
    },
    computed: {
        totalColumns(){
            if(this.$vuetify.breakpoint.xs){
                return 1;
            }

            return 2;
        },
        ordersProductsColumnLength(){
            return Math.ceil(this.ordersProducts.length / this.totalColumns);
        },
        suppliers(){
            let suppliers = {};

            this.ordersProducts.forEach(oP => {
                if(!suppliers[oP.Supplier.ID]){
                    suppliers[oP.Supplier.ID] = {
                        OrdersProducts: [],
                        Name: oP.Supplier.Name,
                        ID: oP.Supplier.ID
                    };
                }

                suppliers[oP.Supplier.ID].OrdersProducts.push(oP);
            });

            return suppliers;
        },
        columns(){
            let columns = [];

            // Starting column
            columns.push({
                ColumnNumber: 1,
                Suppliers: []
            });

            let supplierIDsInOrder = [];
            for(var property in this.suppliers){
                if(this.suppliers.hasOwnProperty(property)){
                    supplierIDsInOrder.push(property);
                }
            }
            supplierIDsInOrder = supplierIDsInOrder.sort((a, b) => {
                if(this.suppliers[a].Name < this.suppliers[b].Name){
                    return -1;
                } else if(this.suppliers[a].Name > this.suppliers[b].Name){
                    return 1;
                }

                return 0;
            });

            for(let j = 0; j < supplierIDsInOrder.length; j++){
                let supplierID = supplierIDsInOrder[j];

                let column = columns.length - 1;
                columns[column].Suppliers.push(this.suppliers[supplierID]);

                let row = 0;
                for(let i = 0; i < columns[column].Suppliers.length; i++){
                    row += columns[column].Suppliers[i].OrdersProducts.length;
                }
                if(row >= this.ordersProductsColumnLength && column < this.totalColumns - 1){
                    // New column
                    columns.push({
                        ColumnNumber: column + 2,
                        Suppliers: []
                    });
                }
            }

            return columns;
        }
    },
    methods : {
        updateSelectedSupplier(supplierID, selected) {
            this.$set(this.value, supplierID, { resendEmail: selected });
            let local = this.value;

            this.$emit('input', local)
        }
    }    
};
</script>

<style>
.supplier {
    page-break-inside: avoid;
    margin-bottom: 8px;
}
</style>
